import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import "../CSS/Misafir_Oda.css"
import loading_ from "../../Assets2/loading.gif";

import { connect } from 'react-redux'
import * as XLSX from 'xlsx';



const DeleteLogs = (props) => {

    const [selected_tag, Set_selected_tag] = useState("")
    const [current_tag, Setcurrent_tag] = useState([])
    const [y_axis, Sety_axis] = useState("")
    const history = useHistory();

    const [state, Set_state] = useState([])

    const [date1, Setdate1] = useState("")
    const [date2, Setdate2] = useState("")

    const [active_number, Set_active_number] = useState(1)

    const [control_loading, Set_control_loading] = useState(false)


    const [render_state, Set_render_state] = useState([])

    const [current_edit_data, Set_current_edit_data] = useState({})

    const onChangeEditM = (e) => {
        const { name, value } = e.target;
        Set_current_edit_data((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const fetchDateObject = (inputDate) => {
        inputDate = new Date(inputDate);
        // Yıl, ay, gün, saat, dakika, saniye, milisaniye parçalarını alıp formatlama
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Ayları 1-12 arasında formatlama
        const day = String(inputDate.getDate()).padStart(2, '0');
        const hours = String(inputDate.getHours()).padStart(2, '0');
        const minutes = String(inputDate.getMinutes()).padStart(2, '0');
        const seconds = String(inputDate.getSeconds()).padStart(2, '0');
        const milliseconds = String(inputDate.getMilliseconds()).padStart(3, '0');

        // Nihai format
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
        return formattedDate

    }

    const fetchDateObjectEndDay = (inputDate) => {
        inputDate = new Date(inputDate);

        // Günü günün sonuna ayarla (23:59:59.999)
        inputDate.setHours(23, 59, 59, 999);

        // Yıl, ay, gün, saat, dakika, saniye, milisaniye parçalarını alıp formatlama
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Ayları 1-12 arasında formatlama
        const day = String(inputDate.getDate()).padStart(2, '0');
        const hours = String(inputDate.getHours()).padStart(2, '0');
        const minutes = String(inputDate.getMinutes()).padStart(2, '0');
        const seconds = String(inputDate.getSeconds()).padStart(2, '0');
        const milliseconds = String(inputDate.getMilliseconds()).padStart(3, '0');

        // Nihai format
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
        return formattedDate;
    };

    // Örnek kullanım:
    console.log(fetchDateObject('Mon Sep 02 2024 00:00:00 GMT+0300'));
    // Çıktı: 2024-09-02 23:59:59.999


    useEffect(() => {
        const componentDidMount = async () => {
            try {

                const req_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/GetTaglist", {
                    method: "POST",
                    body: JSON.stringify({
                        companyId: Number(props.com_id),
                    }),
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                })


                const response = await req_.json()

                Set_state(response)

            } catch (error) {
                console.log(error);
            }
        }

        componentDidMount()
    }, [])




    async function deleteLogs(id, startDate, endDate) {

        try {

            const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/DeleteFromTagLog", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    StartDate: fetchDateObject(startDate),
                    EndDate: fetchDateObjectEndDay(endDate),
                    TagId: id
                })
            })

            const response = await request.json();

            if (request.status === 200) {
                console.log(response);
            }

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => { console.log(render_state); }, [render_state])

    function convertDateToMMDDYYYY(dateString) {
        // Tarihi parçalarına ayır
        let [year, month, day] = dateString.split('-');
        // MM/DD/YYYY formatına dönüştür ve döndür
        return `${month}/${day}/${year}`;
    }

    function clear() {
        Set_render_state([])
        Setdate1("")
        Setdate2("")
        Set_active_number(1)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const pad = (num) => (num < 10 ? '0' + num : num);

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000`;
    };

    // const EditKaydet = async (e) => {
    //     e.preventDefault();

    //     let currentObj = current_edit_data;
    //     let date_ = currentObj.date

    //     date_ = formatDate(date_);

    //     try {
    //         const req_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/UpdateMisafirOda", {
    //             headers: {
    //                 "Accept": "application/json",
    //                 "Content-Type": "application/json"
    //             },
    //             method: "POST",
    //             body: JSON.stringify({
    //                 misafir: currentObj.misafir, oda: currentObj.oda, date: date_
    //             })

    //         })


    //         const response = await req_.json();

    //         if (req_.status === 200) {
    //             const componentDidMount = async () => {
    //                 try {

    //                     const req_ = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/GetMisafirOdaAll", {
    //                         headers: {
    //                             "Accept": "application/json",
    //                             "Content-Type": "application/json"
    //                         },
    //                         method: "GET",

    //                     })

    //                     let new_data = [];

    //                     const response = await req_.json()
    //                     new_data = response

    //                     new_data.sort((a, b) => {
    //                         // Date objeleri oluştur
    //                         let dateA = new Date(a.date);
    //                         let dateB = new Date(b.date);

    //                         // Karşılaştırma yaparak sıralama
    //                         return dateA - dateB;
    //                     });
    //                     console.log(new_data);
    //                     Set_state(new_data)

    //                     let start = new Date(convertDateToMMDDYYYY(date1));
    //                     let end = new Date(convertDateToMMDDYYYY(date2));


    //                     // Listeyi filtrele
    //                     Set_render_state(new_data.filter(item => {
    //                         let itemDate = new Date(item.date);
    //                         console.log(itemDate);
    //                         return itemDate >= start && itemDate <= end;
    //                     }));

    //                 } catch (error) {
    //                     console.log(error);
    //                 }
    //             }

    //             componentDidMount()
    //         }
    //     } catch (err) {
    //         console.log(err);
    //     } finally {
    //         document.querySelector(".edit-popUp-MOIzleme").classList.toggle("edit-popUp-MOIzleme_active")
    //         document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_dark")
    //         Set_current_edit_data({})
    //     }



    // }

    // useEffect(() => {
    //     if (props.yetkilendirme && props.userId !== "") {
    //         let data = props.yetkilendirme;
    //         let newObj = data[props.userId];
    //         if (newObj !== undefined) {
    //             if (newObj["İletişim"]["Y"] === "t") {

    //                 Set_channel_yazma_control(true)
    //             } else {
    //                 Set_channel_yazma_control(false)
    //             }
    //             if (newObj["İletişim"]["S"] === "t") {

    //                 Set_channel_silme_control(true)
    //             } else {
    //                 Set_channel_silme_control(false)
    //             }
    //         }
    //     }
    // }, [props.yetkilendirme])


    const [tag_page_number, Set_tag_page_number] = useState(1)
    const [search_tag, Set_search_tag] = useState("")

    function convertTo24HourAndDMY(dateStr) {
        // Convert the date string into a Date object
        const date = new Date(dateStr);

        // Get day, month, and year in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();

        // Get hours and minutes in 24-hour format
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the time in HH:mm:ss format
        const time24 = `${hours}:${minutes}:${seconds}`;

        // Format the date in DD/MM/YYYY format
        const formattedDate = `${day}/${month}/${year}`;

        return `${formattedDate} - ${time24}`
    }




    return (
        <>



            <section className='misaifr_oda_view_datas'>
                <div className="top">
                    <h1>TagLog Silme</h1>
                    <div style={{ width: "80%" }} className="top1">
                        <div><p>Başlangıç</p> <input onChange={(e) => {
                            console.log(e.target.value);
                            Setdate1(e.target.value)
                        }} value={date1} type="date" className='input_date_type_mo_view' id="inital_date_mo_view" /></div>
                        <div><p>Bitiş</p> <input onChange={(e) => {
                            Setdate2(e.target.value)
                        }} value={date2} type="date" className='input_date_type_mo_view' id="end_date_mo_view" /></div>
                        <div style={{ width: "30%" }} id='flec-divs'>
                            <div
                                onClick={(e) => {
                                    if (!e.target.classList.contains("fa-arrow-right") || !e.target.classList.contains("fa-arrow-left")) {
                                        document.querySelector(".custom_tag_list").classList.toggle("custom_tag_list_active");

                                    }
                                }}
                                className="custom_select_tag_wrapper"
                            >
                                <div className="custom_select_tag_content">
                                    <div title={y_axis} className="custom_tag_header">
                                        <span>{y_axis !== "" ? y_axis.substring(0, 16) : "Tag Seçin"}</span>
                                        <i className="fa-solid fa-filter"></i>
                                    </div>
                                    <ul style={{ maxHeight: "200px", overflow: "hidden auto" }} className="custom_tag_list">
                                        <input
                                            onClick={() => {
                                                document.querySelector(".custom_tag_list").classList.toggle("custom_tag_list_active");
                                            }}
                                            value={search_tag}
                                            onChange={(e) => { Set_search_tag(e.target.value) }}
                                            type="text"
                                            className="custom_search_tag_input"
                                            placeholder="Tag Ara..."
                                        />
                                        {state.filter(item => item.tagName.toLowerCase().includes(search_tag.toLowerCase())).map((item, index) => {
                                            const page_number = tag_page_number;
                                            const aralık_alt = (page_number - 1) * 50;
                                            const aralık_top = page_number * 50;

                                            if (index >= aralık_alt && index < aralık_top) {
                                                return (
                                                    <li

                                                        title={item.tagName + " " + "-" + " " + item.tagId}
                                                        onClick={(e) => {
                                                            Set_selected_tag(e.target.id);
                                                            Sety_axis(e.target.textContent);
                                                            document.querySelector(".custom_tag_list").classList.toggle("custom_tag_list_active");

                                                        }}
                                                        id={item.tagId}
                                                        key={index}
                                                        className="custom_tag_item"
                                                    >
                                                        {item.tagName}
                                                    </li>
                                                );
                                            }
                                        })}
                                        <div className="custom_bottom_arrows">
                                            <div
                                                onClick={() => {
                                                    if (tag_page_number >= 2) {
                                                        Set_tag_page_number(prevNumber => prevNumber - 1);
                                                    }
                                                }}
                                                className="custom_left_arrow"
                                            >
                                                <i className="fa fa-arrow-left"></i>
                                            </div>
                                            <span className="custom_page_number">{tag_page_number}/{Math.ceil(state.length / 50)}</span>
                                            <div
                                                onClick={() => {
                                                    if (Math.ceil(state.length / 50) > tag_page_number) {
                                                        Set_tag_page_number(prevNumber => prevNumber + 1);
                                                    }
                                                }}
                                                className="custom_right_arrow"
                                            >
                                                <i className="fa fa-arrow-right"></i>
                                            </div>
                                        </div>

                                    </ul>
                                </div>
                            </div>



                        </div>
                    </div>
                    <div className="top2">
                        <button style={{ backgroundColor: "crimson", marginTop: "4%", width: "40%", color: "white", pointerEvents: date1 !== "" && date2 !== "" && selected_tag !== "" ? "all" : "none" }} onClick={(e) => {
                            e.preventDefault();
                            if (date1 !== "" && date2 !== "" && selected_tag !== "") {
                                let confirm = window.confirm("Bu işlem veri kaybı ile sonuçlanacaktır. Devam etmek istiyor musunuz?")
                                if (confirm) {
                                    deleteLogs(selected_tag, date1, date2)

                                }
                            } else {
                                alert("Lütfen Tarih ve Tag Seçin!")
                            }
                        }} className='view_btn_mo'>Verileri Sil</button>
                    </div>
                </div>

            </section>
        </>
    )
}

const MapStateToProps = (state) => {
    return {
        com_id: state.project_reducer.company_id, yetkilendirme: state.project_reducer.yetkilendirme_state,
        group_id: state.project_reducer.group_id,
        userId: state.auth_reducer.user_id
    }
}

export default connect(MapStateToProps)(DeleteLogs)